import { effect, inject, Signal, TemplateRef, ViewContainerRef } from "@angular/core";

/**
 * Base directive to display host element depending on some condition.
 * Sub-classes must:
 * - provide themselves via `@Directive`
 * - override the `displayCondition` signal.
 */
export abstract class DisplayIfDirective {
  protected readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  protected readonly viewContainerRef = inject(ViewContainerRef);

  protected abstract readonly displayCondition: Signal<boolean | null | undefined>;

  public constructor() {
    effect(() => {
      this.viewContainerRef.clear();
      if (this.displayCondition()) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    });
  }
}
